import React from "react";
import { Breadcrumbs } from "../components/Breadcrumbs";
import { CommonNumbersSection } from "../components/CommonNumbersSection";
import { InternalLinks } from "../components/InternalLinks";
import { SEOContentSection } from "../components/SEOContentSection";
import { useSEO } from "../hooks/useSEO";
import { SITE_URL } from "../lib/api";
import { relatedFor } from "../data/pages";

export default function CommonNumberPage({ config }) {
  const { result, previous } = relatedFor(config.variant);

  useSEO({
    title: config.title,
    description: config.description,
    path: config.slug,
    jsonLd: [
      {
        "@context": "https://schema.org",
        "@type": "BreadcrumbList",
        itemListElement: [
          { name: "Home", item: SITE_URL + "/" },
          { name: config.kicker, item: SITE_URL + config.slug },
          { name: config.h1, item: SITE_URL + config.slug },
        ].map((it, i) => ({ "@type": "ListItem", position: i + 1, name: it.name, item: it.item })),
      },
    ],
  });

  const content = [
    { h: config.h1, p: config.intro },
    {
      h: "How the common number is generated",
      p: "The common number uses a fixed, date-based method — not random generation — so the same day always shows the same value. Refreshing the page any number of times will never change today's number.",
    },
    {
      h: "Daily schedule (Asia/Kolkata)",
      p: "The common number follows India Standard Time. After 8:00 PM (IST) the schedule automatically switches to the next day's value, keeping the displayed date and number in sync without any manual updates.",
    },
    {
      h: "Important note",
      p: "House and ending numbers are informational references only. This platform does not guarantee any outcome and does not facilitate any game.",
    },
  ];

  return (
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
      <Breadcrumbs items={[{ label: config.kicker }, { label: config.h1 }]} />
      <h1 className="font-head font-black text-3xl sm:text-4xl text-slate-900 mb-2">{config.h1}</h1>
      <p className="text-slate-600 max-w-3xl mb-8 text-[15px] leading-relaxed">{config.intro}</p>

      <CommonNumbersSection variant={config.variant} title={config.h1} />

      <div className="mt-12 grid lg:grid-cols-3 gap-8">
        <div className="lg:col-span-2">
          <SEOContentSection blocks={content} />
        </div>
        <div className="lg:col-span-1 space-y-6">
          <InternalLinks
            title="Related pages"
            links={[
              { label: `${result.h1}`, to: result.slug },
              { label: `${previous.h1}`, to: previous.slug },
              { label: "Home — Live Result", to: "/" },
            ]}
          />
        </div>
      </div>
    </div>
  );
}
